import React, { Component } from "react";
import { Link } from "react-router";
import LandingHeader from "../components/layout/LandingHeader";
import LandingFooter from "../components/layout/LandingFooter";
import NovoEventoService from "../services/Eventos/NovoEventoService";
import { Button, Input, Sidebar } from "../components/ui";
import { Search, MapPin, SlidersHorizontal, CalendarX, Calendar } from "lucide-react";
import SideBarDetailCorrida from "../components/corredor/SideBarDetailCorrida";
import bannerImg from "../statics/img/HERO HOME.png";
import { formatDateBR } from "../utils/dateUtils";
import WhatsAppButton from "../components/common/WhatsAppButton";

class Home extends Component {
    constructor() {
        super();
        this.state = {
            corridas: [],
            fallbackCorridas: [],
            searchQuery: "",
            searchLocation: "",
            selectedCorrida: null,
            visibleDetail: false,
            categorias: []
        };
        this.eventoService = new NovoEventoService();
    }

    componentDidMount() {
        this.loadEventos();
        window.addEventListener("popstate", this.handlePopState);
    }

    componentWillUnmount() {
        window.removeEventListener("popstate", this.handlePopState);
    }

    handlePopState = () => {
        const params = new URLSearchParams(window.location.search);
        const corridaId = params.get("corrida");
        if (corridaId) {
            const corrida = this.state.corridas.find(c => String(c.id) === String(corridaId));
            if (corrida) {
                this.handleVerDetalhes(corrida, false);
            }
        } else if (this.state.visibleDetail) {
            this.setState({ visibleDetail: false, selectedCorrida: null });
        }
    };

    verificarCorridaNaUrl() {
        const params = new URLSearchParams(window.location.search);
        const corridaId = params.get("corrida");
        if (corridaId) {
            const corrida = this.state.corridas.find(c => String(c.id) === String(corridaId));
            if (corrida) {
                this.handleVerDetalhes(corrida, false);
            }
        }
    }

    loadEventos() {
        this.eventoService.getCorridasPublico()
            .then(res => {
                if (!res.ok) {
                    throw new Error("Erro de resposta da API");
                }
                return res.json();
            })
            .then(data => {
                const corridas = (data && data.length > 0) ? data : this.state.fallbackCorridas;
                this.setState({ corridas }, () => {
                    this.verificarCorridaNaUrl();
                });
            })
            .catch(err => {
                console.warn("Utilizando eventos de fallback (servidor offline):", err);
                this.setState({ corridas: this.state.fallbackCorridas }, () => {
                    this.verificarCorridaNaUrl();
                });
            });
    }

    handleCloseDetalhes() {
        this.setState({ visibleDetail: false, selectedCorrida: null });
        const url = new URL(window.location.href);
        if (url.searchParams.has("corrida")) {
            url.searchParams.delete("corrida");
            window.history.pushState({}, "", url.toString());
        }
    }

    handleVerDetalhes(corrida, updateUrl = true) {
        if (updateUrl) {
            const url = new URL(window.location.href);
            url.searchParams.set("corrida", corrida.id);
            window.history.pushState({}, "", url.toString());
        }

        this.setState({ selectedCorrida: corrida, visibleDetail: true, categorias: [] });
        
        // Fetch categories dynamically if possible
        this.eventoService.geCategoriaPorCorrida(corrida.id)
            .then(res => {
                if (res.ok) return res.json();
                return null;
            })
            .then(data => {
                if (data) {
                    this.setState({ categorias: data });
                } else {
                    // Fallback categories if API is offline
                    this.setState({
                        categorias: [
                            { id: 101, nome_categoria: "Geral Masculino 5K", idade_minima: 16, idade_maxima: 99 },
                            { id: 102, nome_categoria: "Geral Feminino 5K", idade_minima: 16, idade_maxima: 99 },
                            { id: 103, nome_categoria: "Geral Masculino 10K", idade_minima: 18, idade_maxima: 99 },
                            { id: 104, nome_categoria: "Geral Feminino 10K", idade_minima: 18, idade_maxima: 99 }
                        ]
                    });
                }
            })
            .catch(() => {
                this.setState({
                    categorias: [
                        { id: 101, nome_categoria: "Geral Masculino 5K", idade_minima: 16, idade_maxima: 99 },
                        { id: 102, nome_categoria: "Geral Feminino 5K", idade_minima: 16, idade_maxima: 99 },
                        { id: 103, nome_categoria: "Geral Masculino 10K", idade_minima: 18, idade_maxima: 99 },
                        { id: 104, nome_categoria: "Geral Feminino 10K", idade_minima: 18, idade_maxima: 99 }
                    ]
                });
            });
    }

    handleInscricao() {
        const token = sessionStorage.getItem('brv-user-token');
        if (token) {
            window.location.href = "/novas-corridas";
        } else {
            sessionStorage.setItem("brv-redirect-after-login", "/novas-corridas");
            window.location.href = "/login";
        }
    }

    render() {
        const { corridas, searchQuery, searchLocation, selectedCorrida, visibleDetail } = this.state;

        // Filter events
        const filteredCorridas = corridas.filter(corrida => {
            const matchesName = (corrida.nome_corrida || "").toLowerCase().includes(searchQuery.toLowerCase());
            const matchesLocation = (corrida.cidade_evento || "").toLowerCase().includes(searchLocation.toLowerCase());
            const isPublicStatus = corrida.status_evento === "Inscrição Aberta" || corrida.status_evento === "Em Preparação" || corrida.status_evento === "Inscrição Encerrada";
            return matchesName && matchesLocation && isPublicStatus;
        });

        const formatDate = (value) => {
            return formatDateBR(value);
        };

        return (
            <div className="landing-page-wrapper bg-gradient-hero min-h-screen flex flex-col justify-between">
                <LandingHeader />

                <main className="flex-1 pb-12">
                    {/* Hero Section Banner */}
                    <section className="w-full relative overflow-hidden flex items-center py-8 md:py-12 mb-8 hero-banner-section">
                        {/* Background Banner Image */}
                        <img
                            src={bannerImg}
                            alt="URBRACE Banner"
                            className="absolute top-0 right-0 h-full w-full z-0 object-cover object-center hero-banner-img opacity-60"
                        />

                        {/* Dark Gradient Overlay */}
                        <div className="absolute top-0 left-0 h-full w-full z-1 hero-banner-overlay bg-gradient-to-r from-urb-dark via-urb-dark/80 to-transparent" />

                        {/* Content over Banner */}
                        <div className="max-w-7xl w-full mx-auto px-4 md:px-6 relative z-10">
                            <div className="max-w-2xl text-left flex flex-col gap-3">
                                <span className="text-urb-primary text-sm md:text-base font-bold tracking-widest uppercase m-0">
                                    PLATAFORMA DE CORRIDA E EXPERIÊNCIAS ESPORTIVAS
                                </span>
                                <h1 className="text-3xl md:text-4xl lg:text-5xl font-black m-0 leading-tight tracking-tight uppercase">
                                    <span className="block text-white">TECNOLOGIA PARA QUEM ORGANIZA.</span>
                                    <span className="block mt-1 text-urb-primary">EXPERIÊNCIA PARA QUEM CORRE.</span>
                                </h1>
                                <div className="text-urb-text-secondary text-sm md:text-base flex flex-col gap-1 mt-2 leading-relaxed">
                                    <p className="m-0">Crie eventos, gerencie inscrições, acompanhe resultados</p>
                                    <p className="m-0">e conecte atletas em uma única plataforma, do planejamento à linha de chegada.</p>
                                </div>
                            </div>
                        </div>
                    </section>

                    {/* Eventos Disponíveis Title */}
                    <div className="max-w-7xl mx-auto px-4 md:px-6">
                        <h2 className="text-2xl md:text-3xl font-extrabold mb-6 text-urb-primary">
                            Eventos Disponíveis
                        </h2>
                    </div>

                    {/* Search and Filters */}
                    <section className="max-w-5xl mx-auto mb-8 p-4 rounded-2xl border border-urb-border bg-urb-card shadow-lg">
                        <div className="grid grid-cols-1 md:grid-cols-12 gap-3 items-center">
                            <div className="md:col-span-6">
                                <Input
                                    icon={Search}
                                    value={searchQuery}
                                    onChange={(e) => this.setState({ searchQuery: e.target.value })}
                                    placeholder="Pesquisar por nome do evento..."
                                    className="bg-urb-dark-surface"
                                />
                            </div>
                            <div className="md:col-span-5">
                                <Input
                                    icon={MapPin}
                                    value={searchLocation}
                                    onChange={(e) => this.setState({ searchLocation: e.target.value })}
                                    placeholder="Cidade ou Estado..."
                                    className="bg-urb-dark-surface"
                                />
                            </div>
                            <div className="md:col-span-1 flex justify-end">
                                <button
                                    type="button"
                                    className="p-2.5 rounded-lg text-urb-text-secondary hover:text-white hover:bg-white/5 border border-urb-border cursor-pointer transition-colors"
                                    aria-label="Filtros avançados"
                                >
                                    <SlidersHorizontal className="w-5 h-5" />
                                </button>
                            </div>
                        </div>
                    </section>

                    {/* Events Grid */}
                    <section className="max-w-7xl mx-auto my-6 px-4 md:px-6 lg:px-8">
                        {filteredCorridas.length === 0 ? (
                            <div className="text-center py-12">
                                <CalendarX className="w-12 h-12 text-urb-text-muted mx-auto mb-3" />
                                <h3 className="text-white text-xl font-bold mb-1">Nenhum evento encontrado</h3>
                                <p className="text-urb-text-secondary text-sm m-0">Tente ajustar seus filtros de pesquisa.</p>
                            </div>
                        ) : (
                            <div className="flex flex-col gap-6 w-full">
                                {filteredCorridas.map((corrida) => (
                                    <div key={corrida.id} className="w-full">
                                        <div className="flex flex-col md:flex-row gap-4 w-full items-stretch">
                                            {/* Left Side: Poster Folder Image */}
                                            <div
                                                className="w-full md:w-3/12 lg:w-2/12 flex-shrink-0 rounded-2xl border border-urb-border relative shadow-md cursor-pointer overflow-hidden h-[190px] bg-urb-card"
                                                onClick={() => this.handleVerDetalhes(corrida)}
                                                role="button"
                                                tabIndex={0}
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter' || e.key === ' ') {
                                                        e.preventDefault();
                                                        this.handleVerDetalhes(corrida);
                                                    }
                                                }}
                                                title="Clique para ver os detalhes da corrida"
                                            >
                                                <img
                                                    src={corrida.folder || "https://images.unsplash.com/photo-1476480862126-209bfaa8edc8?auto=format&fit=crop&w=600&q=80"}
                                                    alt={corrida.nome_corrida}
                                                    className="w-full h-full object-cover transition-transform duration-300 hover:scale-105"
                                                />
                                            </div>

                                            {/* Right Side: Black Event Details Card */}
                                            <div className="w-full md:w-9/12 lg:w-10/12 flex-1 rounded-2xl border border-urb-border p-5 sm:p-6 flex flex-col justify-between gap-4 bg-[#060708]">
                                                {/* Top Tag & Main Info */}
                                                <div className="flex flex-col gap-3">
                                                    {/* Status Badge */}
                                                    <div className="flex items-center gap-2">
                                                        <span className="px-3 py-1 rounded-full text-xs font-extrabold flex items-center gap-2 bg-urb-primary text-black">
                                                            <span className="w-2 h-2 rounded-full inline-block bg-black" />
                                                            {corrida.status_evento || "Inscrições Abertas"}
                                                        </span>
                                                        {corrida.is_gratuita && (
                                                            <span className="px-3 py-1 rounded-full text-xs font-extrabold bg-[#8AE600] text-black">
                                                                Gratuita
                                                            </span>
                                                        )}
                                                    </div>

                                                    {/* Title & Description vs Price Box */}
                                                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 items-start justify-between">
                                                        <div className="lg:col-span-8 flex flex-col gap-2">
                                                            <h3 
                                                                className="text-2xl md:text-3xl font-black text-left m-0 uppercase tracking-tight cursor-pointer hover:underline text-urb-primary" 
                                                                onClick={() => this.handleVerDetalhes(corrida)}
                                                                title="Clique para ver os detalhes da corrida"
                                                            >
                                                                {corrida.nome_corrida}
                                                            </h3>
                                                            <p className="text-urb-text-secondary text-xs md:text-sm m-0 leading-relaxed text-left">
                                                                {corrida.trajeto || corrida.descricao || "A Corrida Teste é um evento experimental criado para validar todas as etapas da plataforma URB RACE, desde a inscrição dos atletas até o processamento do pagamento e a gestão dos participantes. A prova permitirá testar, em ambiente real, a experiência dos corredores e dos organizadores."}
                                                            </p>
                                                        </div>

                                                        {/* Price and Action Box */}
                                                        <div className="lg:col-span-4 flex flex-col items-start lg:items-end justify-start gap-2 text-left lg:text-right">
                                                            {corrida.is_gratuita ? (
                                                                <div className="flex flex-col items-start lg:items-end gap-1">
                                                                    <span className="text-xs font-medium text-urb-text-muted">
                                                                        Inscrição
                                                                    </span>
                                                                    <span className="text-3xl md:text-4xl font-black text-urb-primary">
                                                                        Gratuita
                                                                    </span>
                                                                </div>
                                                            ) : (
                                                                <>
                                                                    {corrida.lote_ativo && (
                                                                        <span className="text-xs font-medium text-urb-text-muted">
                                                                            {corrida.lote_ativo.nome_lote}
                                                                        </span>
                                                                    )}
                                                                    <span className="text-3xl md:text-4xl font-black text-white">
                                                                        {corrida.lote_ativo ? (
                                                                            `R$ ${Number(corrida.lote_ativo.valor).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                                                        ) : corrida.valor_inscricao ? (
                                                                            `R$ ${Number(corrida.valor_inscricao).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`
                                                                        ) : (
                                                                            "—"
                                                                        )}
                                                                    </span>
                                                                </>
                                                            )}
                                                            <Button
                                                                label={corrida.status_evento === "Inscrição Encerrada" ? "Ver Detalhes" : (corrida.is_gratuita ? "Inscrever-se Gratuitamente" : (corrida.lote_ativo ? "Inscreva-se" : "Ver Detalhes"))}
                                                                onClick={() => this.handleVerDetalhes(corrida)}
                                                                variant="primary"
                                                                size="md"
                                                                className="w-full lg:w-auto mt-2 font-extrabold uppercase"
                                                            />
                                                            <button
                                                                type="button"
                                                                onClick={() => this.handleVerDetalhes(corrida)}
                                                                className="bg-transparent border-none text-urb-text-secondary hover:text-white cursor-pointer text-xs mt-1 p-0 transition-colors"
                                                            >
                                                                Ver Regulamento
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* Bottom Metadata Info Icons */}
                                                <div className="flex flex-col sm:flex-row gap-3 sm:gap-6 text-xs text-urb-text-secondary pt-3 border-t border-white/10">
                                                    <div className="flex items-center gap-2">
                                                        <Calendar className="w-4 h-4 text-urb-primary" />
                                                        <span>{formatDate(corrida.data_evento) || formatDate(corrida.inicio_inscricao)}</span>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <MapPin className="w-4 h-4 text-urb-primary" />
                                                        <span>{corrida.cidade_evento || "Macapá - Amapá"}</span>
                                                    </div>
                                                    <div className="flex items-center gap-2">
                                                        <span className="w-2 h-2 rounded-full bg-urb-primary inline-block" />
                                                        <span>
                                                            {corrida.status_evento === "Inscrição Encerrada"
                                                                ? `Inscrições encerradas em ${formatDate(corrida.fim_inscricao) || formatDate(corrida.data_evento)}`
                                                                : `Inscrições abertas até ${formatDate(corrida.fim_inscricao) || formatDate(corrida.data_evento)}`}
                                                        </span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </section>

                    {/* Sidebar Detail Event */}
                    <Sidebar
                        visible={visibleDetail}
                        position="right"
                        onHide={() => this.handleCloseDetalhes()}
                        className="w-full max-w-full lg:w-screen lg:max-w-none bg-urb-dark border-l border-urb-border text-urb-text"
                    >
                        {selectedCorrida && (
                            <SideBarDetailCorrida 
                                produto={selectedCorrida} 
                                onInscricao={() => this.handleInscricao()}
                            />
                        )}
                    </Sidebar>

                    {/* Link para a política de privacidade */}
                    <div className="text-center mt-8 mb-4">
                        <Link 
                            to="/politica-privacidade" 
                            className="text-sm text-urb-text-secondary hover:text-urb-primary transition-colors no-underline"
                        >
                            Política de Privacidade
                        </Link>
                    </div>
                </main>

                <LandingFooter />

                {/* Botão Flutuante do WhatsApp */}
                <WhatsAppButton />
            </div>
        );
    }
}

export default Home;
